const AdminFilterBarStyle = {
  width: "100%",
};

export { AdminFilterBarStyle };
